import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { AlarisProfileService, PROFILE_SERVICE_INJECTOR, RouterDataLink } from '@campaign-portal/components-library';
import { routerLinks } from '@helpers/shared/router-links.const';

@Component({
	selector: 'app-home',
	template: ``,
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
})
export class GoHomeComponent {
	constructor(
		private readonly router: Router,
		@Inject(PROFILE_SERVICE_INJECTOR) private readonly profile: AlarisProfileService
	) {
		const link = Object.values(routerLinks).find((route: RouterDataLink) => {
			return this.profile.allowed(route.data.permissions, route.data.permissionComparison) && !route.data.hiddenMenu;
		});
		this.navigate(link);
	}

	private navigate(link: RouterDataLink | undefined): void {
		this.router.navigate([link?.path]).then();
	}
}
